<template>
  <section class="ranking-wrapper">
    <div class="ranking-head">
      <span class="ranking-title">{{ titulo }}</span>
    </div>

    <div class="ranking-grid">
      <div v-for="(item, index) in totales" :key="index" class="ranking-card">
        <div class="ranking-avatar">
          <img :src="urlImagen(item.imagen)" alt="Miembro" @error="$event.target.src = 'https://via.placeholder.com/64'" />
        </div>

        <div class="ranking-info">
          <div class="ranking-name">{{ item.nombre }}</div>
          <div class="ranking-matricula">Matrícula {{ item.matricula }}</div>
        </div>

        <div class="ranking-total">{{ item.total }}</div>

        <div class="ranking-stars">
          <v-rating
            :value="numeroEstrellas(item.total)"
            half-increments
            readonly
            dense
            size="14"
            color="#C8FF4D"
            background-color="#26262A"
            empty-icon="mdi-star-outline"
            full-icon="mdi-star"
            half-icon="mdi-star-half-full"
          ></v-rating>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Utiles from '../../Servicios/Utiles'

export default {
  name: "CartasTotalesMiembros",
  props: ["totales", "titulo"],

  data: () => ({
    numeroMayor: 0
  }),

  mounted() {
    // Guardia agregada: si totales llega vacío, this.totales[0] sería
    // undefined y .total tronaría. Con arrays vacíos simplemente no hay
    // nada que rankear.
    if (this.totales && this.totales.length > 0) {
      this.numeroMayor = this.totales[0].total
    }
  },

  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    numeroEstrellas(total) {
      if (!this.numeroMayor) return 0;
      return parseFloat(total * 5 / this.numeroMayor)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

.ranking-wrapper {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;

  font-family: var(--font-body);
  color: var(--text-primary);
}

.ranking-head {
  margin-bottom: 14px;
}

.ranking-title {
  font-family: var(--font-mono);
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.ranking-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.ranking-card {
  background: var(--bg);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.ranking-avatar {
  width: 56px;
  height: 56px;
  border-radius: var(--radius);
  overflow: hidden;
  border: 1px solid var(--card-border);
  margin-bottom: 10px;
}

.ranking-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ranking-info {
  margin-bottom: 8px;
}

.ranking-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.ranking-matricula {
  font-size: 11px;
  color: var(--text-tertiary);
  margin-top: 2px;
}

.ranking-total {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 6px;
}

.ranking-stars {
  transform: scale(0.9);
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/CartasTotalesMiembros.vue